module.exports = __webpack_public_path__ + "static/media/NvphStructure2.dccdb0cc.webp";